<template>
  <f7-page class="no-swipeback" id="register-screen">
    <div class="body" :style="bgRegister">
      <b-row  style="height: 100%;">
        <div class="loginPanel loginHeight">
          <div>
            <div class="panel-heading ajust text-center">
              <h4 class="panel-title">
                {{ $t('common.rgstr') }}
              </h4>
            </div>
            <!-- <div class="pilotageTabButtonContainer pilotageTabButtonContainerRegister">
              <f7-grid no-gutter>
                <f7-col width="50" class="pilotageTabController">
                  <f7-link class="pilotageLink" :class="{tabActive: currentRole === 'individual'}"
                    tab-link=".tabIndividual" @click="changeCurrentRole('individual')" active>
                    {{ $t('common.indiv') }}
                  </f7-link>
                </f7-col>
                <f7-col width="50" class="pilotageTabController" disabled>
                  <f7-link class="pilotageLink" style="background:#999;color:#fff !important"
                    :class="{tabActive: currentRole === 'professional'}" tab-link=".tabProfessional"
                    @click="changeCurrentRole('professional')">
                    {{ $t('common.busnss') }}
                  </f7-link>
                </f7-col>
              </f7-grid>
            </div> -->
            <b-tabs class="ml-3 mt-4">
              <b-tab
                :title="$t('common.indiv')"
                tab-link=".tabIndividual"
                @click="changeCurrentRole('individual')" active>
                  <b-row class="mt-4">
                    <b-col cols="8" offset="2" class="form-group">
                      <label>Prénom</label>
                      <div class="form-control"
                        style="display:flex;height: 40px;">
                        <input v-model="firstName_r"
                          inputType="text"
                          style="border:none;width: 100%;"
                          :placeholder="register_FirstName">
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="8" offset="2" class="form-group">
                      <label>Nom de famille</label>
                      <div class="form-control"
                        style="display:flex;height: 40px;">
                        <input v-model="LastName_r"
                          inputType="text"
                          style="border:none;width: 100%;"
                          :placeholder="register_LastName">
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="8" offset="2" class="form-group">
                      <label>Email</label>
                      <div class="form-control"
                        style="display:flex;height: 40px;">
                        <input v-model="email_r"
                          inputType="email"
                          style="border:none;width: 100%;"
                          :placeholder="register_Email">
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="8" offset="2" class="form-group">
                      <form-dropdown-input
                      inputType="text"
                      :placeholderValue="$t('common.enter_ctry')"
                      :itemList="country"
                      v-model="country_r"
                      :customHeight="40"
                      inputLabel="Pays"/>
                    </b-col>
                  </b-row>
                  <b-row required v-if="displayPassword">
                    <b-col cols="8" offset="2" class="form-group">
                      <label>Mot de passe</label>
                      <div class="form-control passwordControl"
                        style="display:flex;height: 40px;">
                        <input v-model="password1_r"
                          :type="passwordFieldType"
                          style="border:none;width: 100%;"
                          :placeholder="register_Password"
                          autocomplete="new-password">
                        <i class="icon icon-password mt-2"
                          :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                          @click="toggleVisibility">
                        </i>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row v-if="displayPassword">
                    <b-col cols="8" offset="2" class="form-group">
                      <label>Répéter le mot de passe</label>
                      <div class="form-control passwordControl"
                        style="display:flex;height: 40px;">
                        <input v-model="password2_r"
                          :type="passwordFieldType_2"
                          style="border:none;width: 100%;"
                          :placeholder="register_RepeatPassword">
                        <i class="icon icon-password mt-2"
                          :class="[isPasswordFieldHidden_2 ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                          @click="toggleVisibility_2">
                        </i>
                      </div>
                    </b-col>
                  </b-row>
                    <!-- <li class="item-content">
                      <div class="item-inner">
                        <div class="item-title">
                          <span v-if="this.country_r === ''">{{ $t('common.ctry') }}</span>
                          <span v-else>{{ country_r }}</span>
                        </div>
                        <div class="item-after">
                          <a href="#" data-picker=".countryListPicker" class="link open-picker button button-round">
                          {{ $t('common.slct') }}
                          </a>
                        </div>
                      </div>
                    </li> -->

              </b-tab>

              <b-tab
                tab-link=".tabProfessional"
                @click="changeCurrentRole('professional')"
                :title="$t('common.busnss')">
                <b-row class="mt-4">
                  <b-col cols="8" offset="2" class="form-group">
                    <label>Nom de l'entreprise</label>
                    <div class="form-control"
                      style="display:flex;height: 40px;">
                      <input v-model="companyName_r"
                        inputType="text"
                        style="border:none;width: 100%;"
                        :placeholder="register_CompanyName">
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="8" offset="2" class="form-group">
                    <label>Numéro de l'entreprise</label>
                    <div class="form-control"
                      style="display:flex;height: 40px;">
                      <input v-model="companyNumber_r"
                        inputType="text"
                        style="border:none;width: 100%;"
                        :placeholder="register_CompanyNumber">
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="8" offset="2" class="form-group">
                    <label>Email</label>
                    <div class="form-control"
                      style="display:flex;height: 40px;">
                      <input v-model="email_r"
                        inputType="email"
                        style="border:none;width: 100%;"
                        :placeholder="register_Email">
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="8" offset="2" class="form-group">
                    <form-dropdown-input
                    inputType="text"
                    :placeholderValue="$t('common.enter_ctry')"
                    :itemList="country"
                    v-model="country_r"
                    :customHeight="40"
                    inputLabel="Pays"/>
                  </b-col>
                </b-row>
                <b-row required v-if="displayPassword">
                  <b-col cols="8" offset="2" class="form-group">
                    <label>Mot de passe</label>
                    <div class="form-control passwordControl"
                      style="display:flex;height: 40px;">
                      <input v-model="password1_r"
                        :type="passwordFieldType_3"
                        style="border:none;width: 100%;"
                        :placeholder="register_Password">
                      <i class="icon icon-password mt-2"
                        :class="[isPasswordFieldHidden_3 ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="toggleVisibility_3">
                      </i>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="displayPassword">
                  <b-col cols="8" offset="2" class="form-group">
                    <label>Répéter le mot de passe</label>
                    <div class="form-control passwordControl"
                      style="display:flex;height: 40px;">
                      <input v-model="password2_r"
                        :type="passwordFieldType_4"
                        style="border:none;width: 100%;"
                        :placeholder="register_RepeatPassword">
                      <i class="icon icon-password mt-2"
                        :class="[isPasswordFieldHidden_4 ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="toggleVisibility_4">
                      </i>
                    </div>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>

            <b-row class="loginButtons">
              <b-col cols="8" offset="2">
                <b-button variant="primary" size="lg"
                  @click="registerNewUser()">
                  {{ $t('common.rgstr') }}
                </b-button>
              </b-col>
            </b-row>

            <b-row class="loginButtons pt-3">
              <b-col cols="8" offset="2">
                <b-button class="loginGoogleButton btn" size="lg"
                  @click="goBack()">
                  <span style="vertical-align: middle; font-size: 13px;">
                    {{ $t('common.bck') }}
                  </span>
                </b-button>
              </b-col>
            </b-row>

            <div class="picker-modal countryListPicker">
              <div class="toolbar">
                <div class="toolbar-inner">
                  <div class="left"></div>
                  <div class="right">
                    <a href="#" class="close-picker orangeBackground" @click="countryListPickerCloseButton">{{ $t('common.bck') }}</a>
                  </div>
                </div>
              </div>
              <div class="picker-modal-inner scrollablePicker">
                <f7-searchbar id="searchCountry"
                  cancel-link="Cancel"
                  search-list=".countryList"
                  placeholder="Search"
                  @searchbar:search="onSearch"
                  @searchbar:clear="onClear">
                </f7-searchbar>
                <div class="list-block countryList">
                  <f7-list contacts class="countryList">
                    <f7-list-group v-for="(group, key) in filteredCountries" :key="key">
                      <f7-list-item :title="key" group-title></f7-list-item>
                      <li v-for="(country, index) in group" :key="'select-country-option-' + index" :value="country">
                        <label class="label-radio item-content" @click="countryListPickerCloseButton">
                          <input type="radio" name="countryPickerRadio" :value="country">
                          <div class="item-inner">
                            <div class="item-title">{{ country }}</div>
                          </div>
                        </label>
                      </li>
                    </f7-list-group>
                  </f7-list>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-row>
    </div>
  </f7-page>
</template>

<script>
import moment from 'moment'

import formDropdownInput from '@/components/common/formDropdownInput.vue'
// import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import {validateEmail} from '@/helpers/validator'

// import design from '@/design/design.json'
import bgImg from '../../assets/static/images/header/accueil.png'

export default {
  components: {
    'form-dropdown-input': formDropdownInput
    // 'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: [
    'FirstName', 'LastName', 'Login', 'Password'
  ],
  data () {
    return {
      bgRegister: 'background-image: url('+ bgImg +');background-position: center; background-size:cover;background-repeat: no-repeat',
      currentRole: 'individual',
      firstName_r: '',
      LastName_r: '',
      companyName_r: '',
      companyNumber_r: '',
      email_r: '',
      countryPicker: '',
      countryPicker2: '',
      country_r: '',
      country_r2: '',
      defaultUrl: '/home/',
      password1_r: '',
      password2_r: '',
      filterBy: '',
      registered: false,
      isPro: false,
      passwordFieldType: 'password',
      passwordFieldType_2: 'password',
      passwordFieldType_3: 'password',
      passwordFieldType_4: 'password',
      accountType: 'Individual',
      fileUpload: 'string',
      colStyle: 'text-align: center; padding-top:5px; padding-bottom:5px;',
      darkColStyle: 'background: #333; text-align: center; padding-top:5px; padding-bottom:5px;',
      country: ['Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegowina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, the Democratic Republic of the', 'Cook Islands', 'Costa Rica', "Cote d'Ivoire", 'Croatia (Hrvatska)', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard and Mc Donald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran (Islamic Republic of)', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', "Korea, Democratic People's Republic of", 'Korea, Republic of', 'Kuwait', 'Kyrgyzstan', "Lao, People's Democratic Republic", 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia, The Former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Moldova, Republic of', 'Monaco', 'Mongolia', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia (Slovak Republic)', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'Spain', 'Sri Lanka', 'St. Helena', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen Islands', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan, Province of China', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Vietnam', 'Virgin Islands (British)', 'Virgin Islands (U.S.)', 'Wallis and Futuna Islands', 'Western Sahara', 'Yemen', 'Yugoslavia', 'Zambia', 'Zimbabwe'],
      countryAlphaTable: {
        A: ['Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan'],
        B: ['Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegowina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi'],
        C: ['Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, the Democratic Republic of the', 'Cook Islands', 'Costa Rica', "Cote d'Ivoire", 'Croatia (Hrvatska)', 'Cuba', 'Cyprus', 'Czech Republic'],
        D: ['Denmark', 'Djibouti', 'Dominica', 'Dominican Republic'],
        E: ['East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia'],
        F: ['Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories'],
        G: ['Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana'],
        H: ['Haiti', 'Heard and Mc Donald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary'],
        I: ['Iceland', 'India', 'Indonesia', 'Iran (Islamic Republic of)', 'Iraq', 'Ireland', 'Israel', 'Italy'],
        J: ['Jamaica', 'Japan', 'Jordan'],
        K: ['Kazakhstan', 'Kenya', 'Kiribati', "Korea, Democratic People's Republic of", 'Korea, Republic of', 'Kuwait', 'Kyrgyzstan'],
        L: ["Lao, People's Democratic Republic", 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 'Liechtenstein', 'Lithuania', 'Luxembourg'],
        M: ['Macau', 'Macedonia, The Former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Moldova, Republic of', 'Monaco', 'Mongolia', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar'],
        N: ['Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway'],
        O: ['Oman'],
        P: ['Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Romania', 'Russian Federation', 'Rwanda'],
        S: ['Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia (Slovak Republic)', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'Spain', 'Sri Lanka', 'St. Helena', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen Islands', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic'],
        T: ['Taiwan, Province of China', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu'],
        U: ['Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan'],
        V: ['Vanuatu', 'Venezuela', 'Vietnam', 'Virgin Islands (British)', 'Virgin Islands (U.S.)'],
        W: ['Wallis and Futuna Islands', 'Western Sahara'],
        Y: ['Yemen', 'Yugoslavia'],
        Z: ['Zambia', 'Zimbabwe']
      },
      displayPassword: true
    }
  },
  computed: {
    filteredCountries () {
      let that = this
      let result = {}
      if (this.filterBy) {
        for (var k in that.countryAlphaTable) {
          for (var i = 0; i < that.countryAlphaTable[k].length; i++) {
            if (that.countryAlphaTable[k][i].toLowerCase().startsWith(this.filterBy.toLowerCase())) {
              if (!Object.hasOwn(result, k)) {
                result[k] = []
              }
              result[k].push(that.countryAlphaTable[k][i])
            }
          }
        }
        this.Dom7('li[class=hidden-by-searchbar]').each(function () {
          that.Dom7(this).removeClass('hidden-by-searchbar')
        })
        return result
      }

      return this.countryAlphaTable
    },
    imgVars () {
      return this.design.fontImage
    },
    isPasswordFieldHidden () {
      return this.passwordFieldType === 'password'
    },
    isPasswordFieldHidden_2 () {
      return this.passwordFieldType_2 === 'password'
    },
    isPasswordFieldHidden_3 () {
      return this.passwordFieldType_3 === 'password'
    },
    isPasswordFieldHidden_4 () {
      return this.passwordFieldType_4 === 'password'
    }
  },
  created () {
    this.register_FirstName = this.$i18n.t('common.enter_first_name')
    this.register_LastName = this.$i18n.t('common.enter_last_name')
    this.register_Email = this.$i18n.t('common.enter_email')
    this.register_Password = this.$i18n.t('common.enter_pwd')
    this.register_RepeatPassword = this.$i18n.t('common.enter_rpt_pwd')
    this.register_CompanyName = this.$i18n.t('common.enter_cmp_nm')
    this.register_CompanyNumber = this.$i18n.t('common.enter_cmp_nb')
    // let that = this
    if (this.FirstName) {
      this.firstName_r = this.FirstName
    } else {
      this.firstName_r = ''
    }
    if (this.LastName) {
      this.LastName_r = this.LastName
    } else {
      this.LastName_r = ''
    }
    this.companyName_r = ''
    this.companyNumber_r = ''
    if (this.Login) {
      this.email_r = this.Login
    } else {
      this.email_r = ''
    }
    this.country_r = ''
    this.country_r2 = ''
    if (this.$engine.user.connectBy === 'vue-google-oauth2') {
      this.password1_r = this.Password
      this.password2_r = this.Password
      this.displayPassword = false
    } else {
      this.password1_r = ''
      this.password2_r = ''
    }
    this.$f7.params.swipePanel = false
  },
  methods: {
    openCountryPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    },
    openCountryPicker2 (e) {
      e.stopPropagation()
      this.countryPicker2.open()
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this

      reader.onload = (e) => {
        vm.fileUpload = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeImage () {
      this.fileUpload = ''
    },
    registerNewUser () {
      const that = this
      var type = ''
      if (that.isPro) {
        type = '1'
      } else {
        type = '2'
      }

      let countryFinal = ''
      if (this.currentRole === 'individual') {
        countryFinal = this.country_r
      } else {
        countryFinal = this.country_r2
      }

      if (that.password1_r !== that.password2_r) {
        that.$f7.alert('Passwords do not match', 'Error')
      } else if (that.isPro && that.password1_r === '') {
        that.$f7.alert('Password missing', 'Error')
      } else if (that.isPro && that.companyName_r === '') {
        that.$f7.alert('Company name missing', 'Error')
      } else if (that.isPro && that.companyNumber_r === '') {
        that.$f7.alert('Company number missing', 'Error')
      } else if (that.isPro && that.fileUpload === '') {
        that.$f7.alert('Company document missing', 'Error')
      } else if (!that.isPro && that.password1_r === '') {
        that.$f7.alert('Password missing', 'Error')
      } else if (!that.isPro && that.firstName_r === '') {
        that.$f7.alert('First name missing', 'Error')
      } else if (!that.isPro && that.LastName_r === '') {
        that.$f7.alert('Last name missing', 'Error')
      } else if (that.email_r === '') {
        that.$f7.alert('Email missing', 'Error')
      } else if (that.email_r.length > 0 && validateEmail(that.email_r) === null) {
        that.$f7.alert('Change the email address to a valid format', 'Invalid Email Address')
        return
      } else if (countryFinal === '') {
        that.$f7.alert('Country missing', 'Error')
      } else {
        this.$f7.showPreloader(this.$i18n.t('registerPage.rgstrng'))
        var connectBySend = ''
        if (that.$engine.user.connectBy === 'vue-google-oauth2') {
          connectBySend = 'vgo'
        } else {
          connectBySend = 'lpc'
        }
        this.$engine.auth.register({
          Type: type,
          First_name: that.firstName_r,
          Last_name: that.LastName_r,
          Login: that.email_r,
          Password: that.password1_r,
          Company_name: that.companyName_r,
          Company_number: that.companyNumber_r,
          Country: countryFinal,
          Document: that.fileUpload,
          Connect_by: connectBySend
        }).then(response => {
          that.$f7.hidePreloader()
          if (response.status === 200) {
            if (that.displayPassword) {
              // On redirige vers la page de connexion
              loadPage(that, {url: '/login/'})
            } else {
              // Comme on s'est déja connecté via Google, on lance directement l'authentification
              that.$f7.showPreloader(that.$t('loginPage.sign_in_loading'))
              var creds = {
                Login: that.email_r,
                Password: that.password1_r,
                ConnectBy: 'vgo'
              }
              let defaultServiceRegisteredAccount = 'Payments'
              this.$engine.auth.login(creds)
              .then(() => {
                // J'existe
                let that = this
                that.$engine.services
                .enroll(1, moment('2020-06-10', 'YYYY-MM-DD'))
                .then(response => {
                  if (response.status === 200) {
                    this.$bus.emit('service:change', defaultServiceRegisteredAccount)
                    this.$bus.emit('login', true)
                    that.$f7.hidePreloader()
                    this.$bus.emit('refresh-cache-menu')
                    // let serviceInbox = '/inbox/0'
                    // loadPage(that, {url: serviceInbox})
                    // that.$f7.popup('#service-switcher-true')
                    if (this.$engine.user.getIsFirstLogin() === '1') {
                      // alert('direct payments')
                      this.$bus.emit('service:change', defaultServiceRegisteredAccount)
                      // loadPage(that, {url: '/inbox/0'})
                      that.$engine.services.payments.update(0, 1, 1,
                        {
                          statusWaiting: 1
                        }
                      )
                      .then(() => {
                        // if (resp.data.payments.length > 0) {
                        //   that.$engine.settings.set({clickedMessage: resp.data.payments[0]})
                        //   that.$engine.settings.set({msgFromInbox: true})
                        //   that.$engine.user.setIsFirstLogin('0')
                        //   loadPage(that, {url: '/directPayments/inbox/'})
                        // } else {
                        //   loadPage(that, {url: '/directPayments/inbox/'})
                        // }
                        /* IRY 04/2020 A la première connexion, on est redirigé vers le dashboard */
                        loadPage(that, {url: that.defaultUrl})
                      })
                      .catch(error => {
                        errorMessageAlert(error, that)
                      })
                    } else {
                      // switch (this.$engine.user.get().favourite_service) {
                      //   case '2' :
                      //     this.$bus.emit('service:change', 'Direct Debit')
                      //     loadPage(that, {url: '/directDebit/inbox/'})
                      //     break
                      //   case '6' :
                      //     this.$bus.emit('service:change', 'Direct Payments')
                      //     loadPage(that, {url: '/directPayments/inbox/'})
                      //     break
                      //   default :
                      //     this.$bus.emit('service:change', 'directPayments')
                      //     loadPage(that, {url: '/directPayments/inbox/'})
                      // }
                      /* IRY 04/2020 A la première connexion, on est redirigé vers le dashboard */
                      loadPage(that, {url: that.defaultUrl})
                    }
                  }
                }).catch(error => {
                  that.$f7.hidePreloader()
                  errorMessageAlert(error, that)
                })
              }).catch(() => {
                // On fail do something
                that.$f7.hidePreloader()
              })
            }
            that.registered = true
            if (that.displayPassword) {
              that.$f7.alert(this.$i18n.t('registerPage.actvtn_lnk_snt'), this.$i18n.t('registerPage.rgstrtn_done'))
            }
          }
        }).catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    choosePro () {
      this.isPro = true
      this.accountType = 'Professional'
    },
    chooseInd () {
      this.isPro = false
      this.accountType = 'Individual'
    },
    openAlert () {
      var self = this
      self.$f7.alert('Feature in progress', 'Not implemented')
    },
    changeCurrentRole (role) {
      this.$f7.closeModal('.countryListPicker.modal-in')
      if (this.currentRole !== role) {
        this.currentRole = role
        if (role === 'individual') {
          this.$$(this.$$('.tabIndividual')[this.$$('.tabIndividual').length - 1]).addClass('active')
          this.$$(this.$$('.tabProfessional')[this.$$('.tabProfessional').length - 1]).removeClass('active')
          this.isPro = false
        } else if (role === 'professional') {
          this.$$(this.$$('.tabProfessional')[this.$$('.tabProfessional').length - 1]).addClass('active')
          this.$$(this.$$('.tabIndividual')[this.$$('.tabIndividual').length - 1]).removeClass('active')
          this.isPro = true
        }
      }
    },
    countryListPickerCloseButton () {
      if (this.Dom7('input[name=countryPickerRadio]:checked').val() !== undefined) {
        this.country_r = this.Dom7('input[name=countryPickerRadio]:checked').val()
        this.country_r2 = this.Dom7('input[name=countryPickerRadio]:checked').val()
      }
      // TLV 04/12/2019 : Fermeture automatique de la liste après avoir choisi un pays
      this.$f7.closeModal('.countryListPicker.modal-in')
    },
    toggleVisibility () {
      // let that = this
      // if (that.Dom7($event.target).hasClass('icon-eye_blind')) {
      //   that.Dom7($event.target).removeClass('icon-eye_blind')
      //   that.Dom7($event.target).addClass('icon-eye')
      //   that.Dom7($event.target).parent().find('input').prop('type', 'text')
      // } else {
      //   that.Dom7($event.target).removeClass('icon-eye')
      //   that.Dom7($event.target).addClass('icon-eye_blind')
      //   that.Dom7($event.target).parent().find('input').prop('type', 'password')
      // }
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
      } else {
        this.passwordFieldType = 'password'
      }
    },
    toggleVisibility_2 () {
      if (this.passwordFieldType_2 === 'password') {
        this.passwordFieldType_2 = 'text'
      } else {
        this.passwordFieldType_2 = 'password'
      }
    },
    toggleVisibility_3 () {
      if (this.passwordFieldType_3 === 'password') {
        this.passwordFieldType_3 = 'text'
      } else {
        this.passwordFieldType_3 = 'password'
      }
    },
    toggleVisibility_4 () {
      if (this.passwordFieldType_4 === 'password') {
        this.passwordFieldType_4 = 'text'
      } else {
        this.passwordFieldType_4 = 'password'
      }
    },
    onSearch (query) {
      this.filterBy = query
    },
    onClear () {
      this.filterBy = ''
    },
    goBack () {
      loadPage(this, {url: '/login/'})
    }
  }
}
</script>

<style scoped>
.registerForm {
  margin-top: 120px;
}

#searchCountry {
  margin-top: 0;
}
.icon-password {
  width: 28px;
  height: 28px;
}
.no-gutter, .card {
  margin-left: 0px;
  margin-right: 0px;
}

</style>
